import BackgroundWrapper from "_components/atoms/backgroundWrapper";
import Icon              from "_components/atoms/icon";
import Typography        from "_components/atoms/typography";
import ConfirmModal      from "_components/molecules/confirmModal";

import useStyles from "./styles";

const ModalHeader = ( { disabled, onClose, title = "", onGoBack, showBackBtn } ) => {
	const { classes } = useStyles ( undefined, { name: "molecules/modalHeader" } );

	return (
		<BackgroundWrapper className = { classes.header }
			type                        = "tertiary"
		>
			<div className = { classes.titleContainer }>
				{
					showBackBtn ? (
						<ConfirmModal
							acceptButtonText = "Leave"
							buttonComponent  = { (
								<Icon
									className = { classes.backIcon }
									name      = "backArrow"
								/>
							) }
							dialogText       = "Are you sure, you want to leave this page? Your progress will be lost."
							dialogTitle      = "Stream Setup in Progress"
							performAction    = { onGoBack }
							rejectButtonText = "Cancel"
						/>

					) : null
				}

				<Typography
					className = { `${ classes.title } fontBold` }
					title     = { title }
				/>
			</div>

			{
				!disabled ? (
					<Icon
						className = { classes.closeIcon }
						name      = "cross"
						onClick   = { onClose }
					/>
				) : null
			}

		</BackgroundWrapper>
	);
};

export default ModalHeader;
